module.exports = __webpack_public_path__ + "images/maskable_icon-192.d4991b6aa19f0f2b9b1cb606a2ded625.png";